webpackJsonp([13],{

/***/ "4ajQ":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("Wdy1");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("qs+f"), 'Object', { defineProperty: __webpack_require__("GCs6").f });


/***/ }),

/***/ "7+u2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iconCloud_vue__ = __webpack_require__("sFnr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367ba28c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_iconCloud_vue__ = __webpack_require__("8k8m");
function injectStyle (ssrContext) {
  __webpack_require__("D7+M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-367ba28c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iconCloud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367ba28c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_iconCloud_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8k8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"cloud",staticClass:"icon-cloud"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bz0q":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".toolbarButtons[data-v-06759b99]{font-weight:700;margin-right:0;padding-left:12px;padding-right:12px}.signupBtn[data-v-06759b99]{border-radius:10px;width:calc(160px + 5vw);margin-left:auto;margin-right:auto;margin-top:20px}.fling-minislide[data-v-06759b99]{width:100%;aspect-ratio:3/6;min-height:330px;overflow:hidden;position:relative;border-radius:15px;border:1px solid silver}.fling-minislide img[data-v-06759b99]{position:absolute;-webkit-animation:fling-minislide-data-v-06759b99 30s infinite;animation:fling-minislide-data-v-06759b99 30s infinite;opacity:0;left:0;min-height:250px;border-radius:15px}@-webkit-keyframes fling-minislide-data-v-06759b99{25%{opacity:1}40%{opacity:0}}@keyframes fling-minislide-data-v-06759b99{25%{opacity:1}40%{opacity:0}}.fling-minislide img[data-v-06759b99]:nth-child(6){-webkit-animation-delay:0s;animation-delay:0s}.fling-minislide img[data-v-06759b99]:nth-child(5){-webkit-animation-delay:5s;animation-delay:5s}.fling-minislide img[data-v-06759b99]:nth-child(4){-webkit-animation-delay:10s;animation-delay:10s}.fling-minislide img[data-v-06759b99]:nth-child(3){-webkit-animation-delay:15s;animation-delay:15s}.fling-minislide img[data-v-06759b99]:nth-child(2){-webkit-animation-delay:20s;animation-delay:20s}.fling-minislide img[data-v-06759b99]:first-child{-webkit-animation-delay:25s;animation-delay:25s}#home[data-v-06759b99]{text-align:center}#toolbar[data-v-06759b99]{position:sticky;width:calc(100% - 20px);top:10px;z-index:100;-ms-flex-item-align:center;align-self:center;margin-left:auto;margin-right:auto;border-radius:10px;-webkit-box-shadow:rgb(0 0 0/20%) 0 1px 5px,rgb(0 0 0/14%) 0 2px 2px,rgb(0 0 0/12%) 0 3px 1px -2px;box-shadow:0 1px 5px rgb(0 0 0/20%),0 2px 2px rgb(0 0 0/14%),0 3px 1px -2px rgb(0 0 0/12%);background-color:#f5f5f5e0}section[data-v-06759b99]{padding-bottom:30px}h2[data-v-06759b99]{text-transform:uppercase;margin-left:5vw;margin-right:5vw;font-size:2.5em;font-weight:900;line-height:1.1}.happySlinkersUL[data-v-06759b99]{text-align:left;list-style-type:none;padding:0}li[data-v-06759b99]{display:inline-block;margin:0 10px}a[data-v-06759b99]{color:#42b983}.googleBtn[data-v-06759b99]{width:100%;border-radius:5px;margin:unset}.testimonials[data-v-06759b99]{background:#f5f5f5;min-height:100px;width:100%;margin:10px;padding:5px;display:-webkit-inline-box;overflow-y:hidden;overflow-x:scroll;gap:15px;scrollbar-width:thin}.testimonials[data-v-06759b99]::-webkit-scrollbar{margin-top:5px;height:5px;width:80%}[data-v-06759b99]::-webkit-scrollbar-track{background:red;margin-top:5px;width:80%}.testimonials[data-v-06759b99]::-webkit-scrollbar-thumb{margin-top:5px;padding:5px;background-color:rgba(0,0,0,.3)}.md-board .testimonial[data-v-06759b99],.testimonials[data-v-06759b99]{-webkit-box-shadow:0 1px 5px rgb(0 0 0/20%),0 2px 2px rgb(0 0 0/14%),0 3px 1px -2px rgb(0 0 0/12%);box-shadow:0 1px 5px rgb(0 0 0/20%),0 2px 2px rgb(0 0 0/14%),0 3px 1px -2px rgb(0 0 0/12%);border-radius:15px;overflow:hidden;display:-webkit-box;display:-ms-flexbox;display:flex;width:100%}.md-board .testimonial img[data-v-06759b99],.testimonials[data-v-06759b99]{aspect-ratio:5/6;width:100px;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}.md-board .testimonial .content[data-v-06759b99],.testimonials[data-v-06759b99]{padding:10px;width:100%;text-align:left}.md-board .testimonial .content .review[data-v-06759b99],.testimonials[data-v-06759b99]{height:calc(100% - 20px)}.md-board .testimonial .content .name[data-v-06759b99],.testimonials[data-v-06759b99]{font-weight:700}.productsContainer[data-v-06759b99]{display:-webkit-box;display:-ms-flexbox;display:flex;gap:20px;margin-top:20px;width:100%;max-width:475px;margin-left:auto;margin-right:auto}.productsContainer .product[data-v-06759b99]{color:#000;width:100%;overflow:hidden;border-radius:15px;-webkit-box-shadow:rgb(0 0 0/20%) 0 1px 5px,rgb(0 0 0/14%) 0 2px 2px,rgb(0 0 0/12%) 0 3px 1px -2px;box-shadow:0 1px 5px rgb(0 0 0/20%),0 2px 2px rgb(0 0 0/14%),0 3px 1px -2px rgb(0 0 0/12%)}.productsContainer .product figure[data-v-06759b99]{margin:unset}.productsContainer .product figure img[data-v-06759b99]{margin:unset;aspect-ratio:4/3;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center}.productsContainer .product figcaption[data-v-06759b99]{margin:5px}.md-snackbar .md-button[data-v-06759b99]:last-child{margin:unset}", "", {"version":3,"sources":["C:/Users/ismet/Documents/Github/slink_vue/src/components/home.vue"],"names":[],"mappings":"AACA,iCACE,gBAAiB,AACjB,eAAkB,AAClB,kBAAmB,AACnB,kBAAoB,CACrB,AACD,4BACE,mBAAmB,AACnB,wBAAwB,AACxB,iBAAiB,AACjB,kBAAkB,AAClB,eAAe,CAChB,AACD,kCACE,WAAW,AACX,iBAAkB,AAClB,iBAAiB,AAEjB,gBAAgB,AAChB,kBAAkB,AAClB,mBAAoB,AACpB,uBAAyB,CAC1B,AACD,sCACE,kBAAkB,AAClB,+DAA+D,AACvD,uDAAuD,AAC/D,UAAU,AACV,OAAS,AACT,iBAAkB,AAClB,kBAAoB,CAErB,AACD,mDACA,IAAI,SAAU,CACb,AACD,IAAI,SAAU,CACb,CACA,AACD,2CACA,IAAI,SAAU,CACb,AACD,IAAI,SAAU,CACb,CACA,AACD,mDAAmD,2BAA2B,kBAAmB,CAChG,AACD,mDAAmD,2BAA2B,kBAAmB,CAChG,AACD,mDAAmD,4BAA4B,mBAAoB,CAClG,AACD,mDAAmD,4BAA4B,mBAAoB,CAClG,AACD,mDAAmD,4BAA4B,mBAAoB,CAClG,AACD,kDAAmD,4BAA4B,mBAAoB,CAClG,AACD,uBACE,iBAAmB,CACpB,AACD,0BAII,gBAAiB,AACjB,wBAAyB,AACzB,SAAU,AACV,YAAa,AACb,2BAA4B,AACxB,kBAAmB,AACvB,iBAAkB,AAClB,kBAAmB,AACnB,mBAAoB,AACpB,mGAAkH,AAC1G,2FAA0G,AAClH,0BAA4B,CAC/B,AACD,yBACE,mBAAoB,CACrB,AACD,oBACE,yBAAyB,AACzB,gBAAgB,AAChB,iBAAiB,AACjB,gBAAiB,AACjB,gBAAgB,AAChB,eAAiB,CAClB,AACD,kCACE,gBAAiB,AACjB,qBAAsB,AACtB,SAAW,CACZ,AACD,oBACE,qBAAsB,AACtB,aAAe,CAChB,AACD,mBACE,aAAe,CAChB,AACD,4BACE,WAAW,AACX,kBAAkB,AAClB,YAAY,CAEb,AACD,+BACE,mBAAsB,AAClB,iBAAkB,AACpB,WAAY,AACZ,YAAY,AACZ,YAAY,AACZ,2BAA4B,AAC5B,kBAAmB,AACnB,kBAAkB,AAClB,SAAU,AACV,oBAAsB,CACzB,AACD,kDACE,eAAe,AACf,WAAW,AACX,SAAS,CACV,AACD,2CACE,eAAgB,AAChB,eAAe,AACf,SAAS,CACV,AACD,wDACE,eAAe,AACf,YAAY,AACV,+BAAoC,CACvC,AACD,uEACE,mGAA2G,AACnG,2FAAmG,AAC3G,mBAAoB,AACpB,gBAAgB,AAGhB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,UAAU,CACX,AACD,2EACI,iBAAkB,AAClB,YAAa,AACb,oBAAqB,AAClB,iBAAkB,AACrB,0BAA2B,AACxB,sBAAwB,CAC9B,AACD,gFACE,aAAa,AACb,WAAW,AACX,eAAiB,CAIlB,AACD,wFACE,wBAAyB,CAC1B,AACD,sFACE,eAAkB,CACnB,AACD,oCACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,SAAU,AACV,gBAAiB,AACjB,WAAY,AACZ,gBAAiB,AACjB,iBAAiB,AACjB,iBAAiB,CAClB,AACD,6CACE,WAAY,AACZ,WAAW,AACX,gBAAiB,AACjB,mBAAmB,AACnB,mGAAkH,AAC1G,0FAA0G,CACnH,AACD,oDACE,YAAY,CACb,AACD,wDACE,aAAa,AACb,iBAAkB,AAClB,oBAAqB,AAClB,iBAAkB,AACrB,0BAA2B,AACxB,sBAAwB,CAC5B,AACD,wDACE,UAAU,CACX,AACD,oDACE,YAAY,CACb","file":"home.vue","sourcesContent":["\n.toolbarButtons[data-v-06759b99]{\r\n  font-weight:bold;\r\n  margin-right: 0px;\r\n  padding-left: 12px;\r\n  padding-right: 12px;\n}\n.signupBtn[data-v-06759b99]{\r\n  border-radius:10px;\r\n  width:calc(160px + 5vw);\r\n  margin-left:auto;\r\n  margin-right:auto;\r\n  margin-top:20px\n}\n.fling-minislide[data-v-06759b99] {\r\n  width:100%; \r\n  aspect-ratio: 3/6;\r\n  min-height:330px; \r\n  /* height:50vh;  */\r\n  overflow:hidden; \r\n  position:relative; \r\n  border-radius: 15px;\r\n  border: 1px solid silver;\n}\n.fling-minislide img[data-v-06759b99]{ \r\n  position:absolute; \r\n  -webkit-animation:fling-minislide-data-v-06759b99 30s infinite; \r\n          animation:fling-minislide-data-v-06759b99 30s infinite; \r\n  opacity:0; \r\n  left:0px; \r\n  min-height: 250px;\r\n  border-radius: 15px;\r\n  /* aspect-ratio:1080/1920 */\n}\n@-webkit-keyframes fling-minislide-data-v-06759b99 {\n25%{opacity:1;\n}\n40%{opacity:0;\n}\n}\n@keyframes fling-minislide-data-v-06759b99 {\n25%{opacity:1;\n}\n40%{opacity:0;\n}\n}\n.fling-minislide img[data-v-06759b99]:nth-child(6){-webkit-animation-delay:0s;animation-delay:0s;\n}\n.fling-minislide img[data-v-06759b99]:nth-child(5){-webkit-animation-delay:5s;animation-delay:5s;\n}\n.fling-minislide img[data-v-06759b99]:nth-child(4){-webkit-animation-delay:10s;animation-delay:10s;\n}\n.fling-minislide img[data-v-06759b99]:nth-child(3){-webkit-animation-delay:15s;animation-delay:15s;\n}\n.fling-minislide img[data-v-06759b99]:nth-child(2){-webkit-animation-delay:20s;animation-delay:20s;\n}\n.fling-minislide img[data-v-06759b99]:nth-child(1){-webkit-animation-delay:25s;animation-delay:25s;\n}\n#home[data-v-06759b99]{\r\n  text-align: center;\n}\n#toolbar[data-v-06759b99]{\r\n    /* position:sticky; */\r\n    /* top:0px; */\r\n    /* z-index:100; */\r\n    position: sticky;\r\n    width: calc(100% - 20px);\r\n    top: 10px;\r\n    z-index: 100;\r\n    -ms-flex-item-align: center;\r\n        align-self: center;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    border-radius: 10px;\r\n    -webkit-box-shadow: rgb(0 0 0 / 20%) 0px 1px 5px, rgb(0 0 0 / 14%) 0px 2px 2px, rgb(0 0 0 / 12%) 0px 3px 1px -2px;\r\n            box-shadow: rgb(0 0 0 / 20%) 0px 1px 5px, rgb(0 0 0 / 14%) 0px 2px 2px, rgb(0 0 0 / 12%) 0px 3px 1px -2px;\r\n    background-color: #f5f5f5e0;\n}\nsection[data-v-06759b99]{\r\n  padding-bottom:30px;\n}\nh2[data-v-06759b99]{\r\n  text-transform:uppercase;\r\n  margin-left:5vw;\r\n  margin-right:5vw;\r\n  font-size: 2.5em;\r\n  font-weight:900;\r\n  line-height: 1.1;\n}\n.happySlinkersUL[data-v-06759b99] {\r\n  text-align: left;\r\n  list-style-type: none;\r\n  padding: 0;\n}\nli[data-v-06759b99] {\r\n  display: inline-block;\r\n  margin: 0 10px;\n}\na[data-v-06759b99] {\r\n  color: #42b983;\n}\n.googleBtn[data-v-06759b99] {\r\n  width:100%;\r\n  border-radius:5px;\r\n  margin:unset\r\n  /* margin-bottom:10px; */\n}\n.testimonials[data-v-06759b99]{\r\n  background:whitesmoke;\r\n      min-height: 100px;\r\n    width: 100%;\r\n    margin:10px;\r\n    padding:5px;\r\n    display: -webkit-inline-box;\r\n    overflow-y: hidden;\r\n    overflow-x:scroll;\r\n    gap: 15px; \r\n    scrollbar-width: thin;\n}\n.testimonials[data-v-06759b99]::-webkit-scrollbar {\r\n  margin-top:5px;\r\n  height:5px;\r\n  width:80%\n}\n[data-v-06759b99]::-webkit-scrollbar-track {\r\n  background: red;\r\n  margin-top:5px;\r\n  width:80%\n}\n.testimonials[data-v-06759b99]::-webkit-scrollbar-thumb {\r\n  margin-top:5px;\r\n  padding:5px;\r\n    background-color: rgba(0, 0, 0, .3); /* Or any other instruction making the element visible */\n}\n.testimonials[data-v-06759b99],.md-board .testimonial[data-v-06759b99]{\r\n  -webkit-box-shadow:0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);\r\n          box-shadow:0 1px 5px rgb(0 0 0 / 20%), 0 2px 2px rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 12%);\r\n  border-radius: 15px;\r\n  overflow:hidden;\r\n  /* border: 1px solid black; */\r\n  /* gap:10px; */\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  width:100%\n}\n.testimonials[data-v-06759b99],.md-board .testimonial img[data-v-06759b99]{\r\n    aspect-ratio: 5/6;\r\n    width: 100px;\r\n    -o-object-fit: cover;\r\n       object-fit: cover;\r\n    -o-object-position: center;\r\n       object-position: center;\n}\n.testimonials[data-v-06759b99],.md-board .testimonial .content[data-v-06759b99]{\r\n  padding:10px;\r\n  width:100%;\r\n  text-align: left;\r\n  /* aspect-ratio: 1/1; */\r\n    /* width: 40%; */\r\n    /* object-fit: cover; */\n}\n.testimonials[data-v-06759b99],.md-board .testimonial .content .review[data-v-06759b99]{\r\n  height:calc(100% - 20px);\n}\n.testimonials[data-v-06759b99],.md-board .testimonial .content .name[data-v-06759b99]{\r\n  font-weight: bold;\n}\n.productsContainer[data-v-06759b99]{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-top: 20px;\r\n  width: 100%;\r\n  max-width: 475px;\r\n  margin-left:auto;\r\n  margin-right:auto\n}\n.productsContainer .product[data-v-06759b99]{\r\n  color:black;\r\n  width:100%;\r\n  overflow: hidden;\r\n  border-radius:15px; \r\n  -webkit-box-shadow: rgb(0 0 0 / 20%) 0px 1px 5px, rgb(0 0 0 / 14%) 0px 2px 2px, rgb(0 0 0 / 12%) 0px 3px 1px -2px; \r\n          box-shadow: rgb(0 0 0 / 20%) 0px 1px 5px, rgb(0 0 0 / 14%) 0px 2px 2px, rgb(0 0 0 / 12%) 0px 3px 1px -2px;\n}\n.productsContainer .product figure[data-v-06759b99]{\r\n  margin:unset\n}\n.productsContainer .product figure img[data-v-06759b99]{\r\n  margin:unset;\r\n  aspect-ratio: 4/3; \r\n  -o-object-fit: cover; \r\n     object-fit: cover;\r\n  -o-object-position: center;\r\n     object-position: center;\n}\n.productsContainer .product figcaption[data-v-06759b99]{\r\n  margin:5px\n}\n.md-snackbar .md-button[data-v-06759b99]:last-child{\r\n  margin:unset\n}\r\n\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "C4MV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("rKx+"), __esModule: true };

/***/ }),

/***/ "D7+M":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("lgQ+");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("5d26b888", content, true, {});

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__("kxiW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__ = __webpack_require__("89vL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__iconCloud_vue__ = __webpack_require__("7+u2");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var db = __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].database();

var remoteConfig = __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].remoteConfig();
remoteConfig.settings = {
  minimumFetchIntervalMillis: 3000
  // minimumFetchIntervalMillis: 3600000,
};

remoteConfig.ensureInitialized().then(function () {}).catch(function (err) {
  console.error('Firebase Remote Config failed to initialize', err);
});

// remoteConfig.fetchAndActivate()
// .then((activated) => {
//   if (!activated) console.log('Fetched data not activated');
//   console.log('Fetched data activated');
//   this.country = remoteConfig.getValue('country')._value
//   console.log('remoteConfig', this.country)
// })
// .catch((err) => {
//   console.error('Error fetching and activating data', err);
// });


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    IconCloud: __WEBPACK_IMPORTED_MODULE_5__iconCloud_vue__["a" /* default */]
  },
  name: 'SlinkView',
  metaInfo: function metaInfo() {
    return {
      script: [],
      // noscript: [
      //   { innerHTML: this.fbPixelNoScript }
      // ]
      link: []
    };
  },

  data: function data() {
    return {
      logos: ['https://cdn.brandfetch.io/ido5G85nya/theme/light/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id-0D6OFrq/theme/dark/idGIofJnQn.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idS5WhqBbM/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idJFz6sAsl/w/400/h/400/theme/dark/icon.png?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id20mQyGeY/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idpKX136kp/w/2084/h/2084/theme/dark/logo.png?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id4VHp4_C_/theme/light/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idVfYwcuQz/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id3gkQXO6j/w/400/h/400/theme/dark/icon.jpeg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idfA0qI6In/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id2UDPob7G/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idM8Hlme1a/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id6O2oGzv-/theme/dark/idncaAgFGT.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id68S6e-Gp/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idItVJklDc/theme/dark/logo.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idGP0S1Jjj/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idAgPm7IvG/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id-Wd4a4TS/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/idcZxK_wH8/theme/light/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B', 'https://cdn.brandfetch.io/id5o3EIREg/theme/dark/symbol.svg?c=1dxbfHSJFAPEGdCLU4o5B'],
      country: null,
      loginEmail: '',
      loginPassword: '',
      signupEmail: '',
      signupPassword: '',
      notification: '',
      images: [// Add your image URLs here
      { src: 'https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/aokmusic_qj_8uWh2I.png' }, { src: 'https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/emtfilms_C-1nJmS-Ra.png' }, { src: 'https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/localhost_8080_thecleopatraway(iPhone%2012%20Pro)_QvMhTd4G9.png' }],
      isDev: window.location.href.indexOf('slinkdev') != -1 || window.location.href.indexOf('localhost') != -1 ? true : false
    };
  },
  // async beforecreate(){
  //   this.getCountry()
  // },
  created: function created() {
    // this.country = remoteConfig.getValue('country')._value
    // console.log('created', this.country)
    console.log('isDev', this.isDev);
    this.getCountry();
  },
  mounted: function mounted() {
    console.log('check for affiliate', this.$route.params.affiliatecode);
    // console.log('getCountry', this.getCountry)

  },
  computed: {},
  methods: {
    getCountry: function getCountry() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var countryValue;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return remoteConfig.fetchAndActivate();

              case 2:
                _context.next = 4;
                return remoteConfig.getValue('country')._value;

              case 4:
                countryValue = _context.sent;

                _this.country = countryValue;
                // console.log('dirty bud buds', this.country, countryValue)
                _context.next = 8;
                return _this.country;

              case 8:
                return _context.abrupt('return', _context.sent);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // screenshotHeight: function(object){
    //   console.log('image width',  object, document.getElementById(object))
    // },
    forgotPassword: function forgotPassword(email) {
      console.log('forgotPassword', email);
      if (!email) {
        this.showNotification('Please enter your email address');
      } else {
        var self = this;
        __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth().sendPasswordResetEmail(email).then(function () {
          self.gGALog(email, "Login", "Password Reset Email");
          self.showNotification('Password reset email sent');
        }).catch(function (error) {
          self.showNotification(error.message);
          self.gGALog(email, "Login", "Password Reset Email Failed");
        });
      }
    },

    // showNotification(message){
    //   this.notification = message;
    //   this.$refs.snackbar.open();
    // },
    openExternal: function openExternal(url) {
      window.open(url, '_blank');
    },
    openDialog: function openDialog(ref) {
      console.log('country', this.country);
      this.gGALog('Home', 'CTA', ref);
      this.$refs[ref].open();
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    },
    createNewUser: function createNewUser(user) {
      // console.log('new user', user)
      var username = user.email.split("@", 1)[0].replace(/[\W\\_]/g, '').toLowerCase();
      var url = user.email.split("@", 1)[0].replace(/[\W\\_]/g, '').toLowerCase();
      if (user.displayName != null) {
        username = user.displayName;
      }
      var picture = "";
      if (user.photoURL != null) {
        picture = user.photoURL;
      }
      try {
        var _db$ref$update;

        var stripeConnect = this.$route.params.affiliatecode ? "acct_" + this.$route.params.affiliatecode : null;
        var referrer = this.$route.query.utm_source ? this.$route.query.utm_source : null;
        var newUser = db.ref('users/' + user.uid + '/').update((_db$ref$update = {
          autoBackground: true,
          name: username,
          altProfile: 0,
          ad: false,
          picture: picture,
          url: url,
          account: 0,
          onboarding: true,
          email: user.email,
          bio: 'Welcome to my Slink Page'
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_db$ref$update, 'ad', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_db$ref$update, 'socialShare', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_db$ref$update, 'referrer', referrer), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_db$ref$update, 'pictureShape', 'squircle'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_db$ref$update, 'stripeConnect', stripeConnect), _db$ref$update));
        if (!__WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].auth().currentUser.emailVerified) {
          __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].auth().currentUser.sendEmailVerification();
        }
      } catch (e) {
        console.log(e);
      }
      db.ref("url/" + user.uid).update({ url: url });
      if (this.$route.query.utm_source) {
        this.gGALog(user.uid, "SignUp Referral", this.$route.query.utm_source);
      }
    },

    loginByGoogle: function loginByGoogle() {
      var _this2 = this;

      var provider = new __WEBPACK_IMPORTED_MODULE_3_firebase___default.a.auth.GoogleAuthProvider();
      __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].auth().signInWithPopup(provider).then(function (result) {
        var self = _this2;
        console.log('login with google', result.user.uid);
        db.ref("users/" + result.user.uid + "/url").once('value').then(function (snapshot) {
          if (snapshot.val() === null) {
            self.createNewUser(result.user);
            self.gGALog(result.user.uid, "SignUp", "SignUp Google");
          }
        });
        _this2.$router.replace({ name: 'Admin' });
        _this2.user = result.user;
        _this2.gGALog(result.user.uid, "Login", "Login Google");
      }).catch(function (err) {
        _this2.showNotification(err.message);

        console.log(err);
      });

      // self.showNotification(error.message);
    },
    loginByEmail: function loginByEmail() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].auth().signInWithEmailAndPassword(this.loginEmail.toLowerCase().trim(), this.loginPassword).then(function (user) {
        // console.log('login with email', user.user.uid)
        _this3.gGALog(user.user.uid, "Login", "Login Email");
        _this3.$router.replace({ name: 'Admin' });
      }, function (err) {
        _this3.gGALog(_this3.loginEmail, "Login Failed", err.message);
        console.log('login error', err);
        if (err.message == 'The password is invalid or the user does not have a password.' && _this3.loginEmail.toLowerCase().indexOf != -1) {
          _this3.showNotification("Incorrect password. If you registered with a Google account please try the 'Login with Google' option");
        } else if (err.code == "auth/user-not-found") {
          _this3.showNotification("Account not found, please check email and retry");
        } else {
          _this3.showNotification(err.message);
        }
      });
    },
    signupByEmail: function signupByEmail() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4__firebaseconfig__["b" /* fb */].auth().createUserWithEmailAndPassword(this.signupEmail.toLowerCase().trim(), this.signupPassword).then(function (success) {
        _this4.createNewUser(success.user);
        // console.log(success.user.uid)
        _this4.gGALog(success.user.uid, "SignUp", "SignUp Email");
      }).catch(function (err) {
        if (err.message.includes("Failed to execute")) {}
        // console.log(err);
        // this.error = err;
        _this4.showNotification(err.message);
        _this4.gGALog(_this4.signupEmail, "Signup Failed", err.message);
      });
    }
  }
});

/***/ }),

/***/ "Tksi":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * TagCloud.js v2.5.0
 * Copyright (c) 2016-2024 @ Cong Min
 * MIT License - https://github.com/mcc108/TagCloud
 */
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.TagCloud = factory());
}(this, (function () { 'use strict';

  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  /**
   * TagCloud.js (c) 2016-2019 @ Cong Min
   * MIT License - https://github.com/cong-min/TagCloud
   */
  var TagCloud = /*#__PURE__*/function () {
    /* constructor */
    function TagCloud() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
      var texts = arguments.length > 1 ? arguments[1] : undefined;
      var options = arguments.length > 2 ? arguments[2] : undefined;
      _classCallCheck(this, TagCloud);
      var self = this;
      if (!container || container.nodeType !== 1) return new Error('Incorrect element type');

      // params
      self.$container = container;
      self.texts = texts || [];
      self.config = _objectSpread2(_objectSpread2({}, TagCloud._defaultConfig), options || {});

      // calculate config
      self.radius = self.config.radius; // rolling radius
      self.depth = 2 * self.radius; // rolling depth
      self.size = 1.5 * self.radius; // rolling area size with mouse
      self.maxSpeed = TagCloud._getMaxSpeed(self.config.maxSpeed); // rolling max speed
      self.initSpeed = TagCloud._getInitSpeed(self.config.initSpeed); // rolling init speed
      self.direction = self.config.direction; // rolling init direction
      self.keep = self.config.keep; // whether to keep rolling after mouse out area
      self.paused = false; // keep state to pause the animation

      // create element
      self._createElment();
      // init
      self._init();
      // set elements and instances
      TagCloud.list.push({
        el: self.$el,
        container: container,
        instance: self
      });
    }

    /* static method */
    // all TagCloud list
    _createClass(TagCloud, [{
      key: "_createElment",
      value: /* instance property method */
      // create elment
      function _createElment() {
        var self = this;

        // create container
        var $el = document.createElement('div');
        $el.className = self.config.containerClass;
        if (self.config.useContainerInlineStyles) {
          $el.style.position = 'relative';
          $el.style.width = "".concat(2 * self.radius, "px");
          $el.style.height = "".concat(2 * self.radius, "px");
        }

        // create texts
        self.items = [];
        self.texts.forEach(function (text, index) {
          var item = self._createTextItem(text, index);
          $el.appendChild(item.el);
          self.items.push(item);
        });
        self.$container.appendChild($el);
        self.$el = $el;
      }

      // create a text
    }, {
      key: "_createTextItem",
      value: function _createTextItem(text) {
        var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var self = this;
        var itemEl = document.createElement('span');
        itemEl.className = self.config.itemClass;
        if (self.config.useItemInlineStyles) {
          itemEl.style.willChange = 'transform, opacity, filter';
          itemEl.style.position = 'absolute';
          itemEl.style.top = '50%';
          itemEl.style.left = '50%';
          itemEl.style.zIndex = index + 1;
          itemEl.style.filter = 'alpha(opacity=0)';
          itemEl.style.opacity = 0;
          var transformOrigin = '50% 50%';
          itemEl.style.WebkitTransformOrigin = transformOrigin;
          itemEl.style.MozTransformOrigin = transformOrigin;
          itemEl.style.OTransformOrigin = transformOrigin;
          itemEl.style.transformOrigin = transformOrigin;
          var transform = 'translate3d(-50%, -50%, 0) scale(1)';
          itemEl.style.WebkitTransform = transform;
          itemEl.style.MozTransform = transform;
          itemEl.style.OTransform = transform;
          itemEl.style.transform = transform;
        }
        if (self.config.useHTML) {
          itemEl.innerHTML = text;
        } else {
          itemEl.innerText = text;
        }
        return _objectSpread2({
          el: itemEl
        }, self._computePosition(index));
      }

      // calculate appropriate place
    }, {
      key: "_computePosition",
      value: function _computePosition(index) {
        var random = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var self = this;
        var textsLength = self.texts.length;
        // if random `true`, It means that a random appropriate place is generated, and the position will be independent of `index`
        if (random) index = Math.floor(Math.random() * (textsLength + 1));
        var phi = Math.acos(-1 + (2 * index + 1) / textsLength);
        var theta = Math.sqrt((textsLength + 1) * Math.PI) * phi;
        return {
          x: self.size * Math.cos(theta) * Math.sin(phi) / 2,
          y: self.size * Math.sin(theta) * Math.sin(phi) / 2,
          z: self.size * Math.cos(phi) / 2
        };
      }
    }, {
      key: "_requestInterval",
      value: function _requestInterval(fn, delay) {
        var requestAnimFrame = (function () {
          return window.requestAnimationFrame;
        } || function (callback, element) {
          window.setTimeout(callback, 1000 / 60);
        })();
        var start = new Date().getTime();
        var handle = {};
        function loop() {
          handle.value = requestAnimFrame(loop);
          var current = new Date().getTime(),
            delta = current - start;
          if (delta >= delay) {
            fn.call();
            start = new Date().getTime();
          }
        }
        handle.value = requestAnimFrame(loop);
        return handle;
      }

      // init
    }, {
      key: "_init",
      value: function _init() {
        var self = this;
        self.active = false; // whether the mouse is activated

        self.mouseX0 = self.initSpeed * Math.sin(self.direction * (Math.PI / 180)); // init distance between the mouse and rolling center x axis
        self.mouseY0 = -self.initSpeed * Math.cos(self.direction * (Math.PI / 180)); // init distance between the mouse and rolling center y axis

        self.mouseX = self.mouseX0; // current distance between the mouse and rolling center x axis
        self.mouseY = self.mouseY0; // current distance between the mouse and rolling center y axis

        var isTouchDevice = window.matchMedia('(hover: hover)');
        if (!isTouchDevice || isTouchDevice.matches) {
          // mouseover
          TagCloud._on(self.$el, 'mouseover', function () {
            self.active = true;
          });
          // mouseout
          TagCloud._on(self.$el, 'mouseout', function () {
            self.active = false;
          });
          // mousemove
          TagCloud._on(self.keep ? window : self.$el, 'mousemove', function (ev) {
            ev = ev || window.event;
            var rect = self.$el.getBoundingClientRect();
            self.mouseX = (ev.clientX - (rect.left + rect.width / 2)) / 5;
            self.mouseY = (ev.clientY - (rect.top + rect.height / 2)) / 5;
          });
        }

        // update state regularly
        self._next(); // init update state
        self.interval = self._requestInterval(function () {
          self._next.call(self);
        }, 10);
      }

      // calculate the next state
    }, {
      key: "_next",
      value: function _next() {
        var self = this;
        if (self.paused) {
          return;
        }

        // if keep `false`, pause rolling after moving mouse out area
        if (!self.keep && !self.active) {
          self.mouseX = Math.abs(self.mouseX - self.mouseX0) < 1 ? self.mouseX0 : (self.mouseX + self.mouseX0) / 2; // reset distance between the mouse and rolling center x axis
          self.mouseY = Math.abs(self.mouseY - self.mouseY0) < 1 ? self.mouseY0 : (self.mouseY + self.mouseY0) / 2; // reset distance between the mouse and rolling center y axis
        }

        var a = -(Math.min(Math.max(-self.mouseY, -self.size), self.size) / self.radius) * self.maxSpeed;
        var b = Math.min(Math.max(-self.mouseX, -self.size), self.size) / self.radius * self.maxSpeed;

        // inverse direction if enabled
        if (self.config.reverseDirection) {
          a = -a;
          b = -b;
        }
        if (Math.abs(a) <= 0.01 && Math.abs(b) <= 0.01) return; // pause

        // calculate offset
        var l = Math.PI / 180;
        var sc = [Math.sin(a * l), Math.cos(a * l), Math.sin(b * l), Math.cos(b * l)];
        self.items.forEach(function (item) {
          var rx1 = item.x;
          var ry1 = item.y * sc[1] + item.z * -sc[0];
          var rz1 = item.y * sc[0] + item.z * sc[1];
          var rx2 = rx1 * sc[3] + rz1 * sc[2];
          var ry2 = ry1;
          var rz2 = rz1 * sc[3] - rx1 * sc[2];
          var per = 2 * self.depth / (2 * self.depth + rz2); // todo

          item.x = rx2;
          item.y = ry2;
          item.z = rz2;
          item.scale = per.toFixed(3);
          var alpha = per * per - 0.25;
          alpha = (alpha > 1 ? 1 : alpha).toFixed(3);
          var itemEl = item.el;
          var left = (item.x - itemEl.offsetWidth / 2).toFixed(2);
          var top = (item.y - itemEl.offsetHeight / 2).toFixed(2);
          var transform = "translate3d(".concat(left, "px, ").concat(top, "px, 0) scale(").concat(item.scale, ")");
          itemEl.style.WebkitTransform = transform;
          itemEl.style.MozTransform = transform;
          itemEl.style.OTransform = transform;
          itemEl.style.transform = transform;
          itemEl.style.filter = "alpha(opacity=".concat(100 * alpha, ")");
          itemEl.style.opacity = alpha;
        });
      }

      /* export instance properties and methods */
      // update
    }, {
      key: "update",
      value: function update(texts) {
        var self = this;
        // params
        self.texts = texts || [];
        // judging and processing items based on texts
        self.texts.forEach(function (text, index) {
          var item = self.items[index];
          if (!item) {
            // if not had, then create
            item = self._createTextItem(text, index);
            _extends(item, self._computePosition(index, true)); // random place
            self.$el.appendChild(item.el);
            self.items.push(item);
          }
          // if had, replace text
          if (self.config.useHTML) {
            item.el.innerHTML = text;
          } else {
            item.el.innerText = text;
          }
        });
        // remove redundant self.items
        var textsLength = self.texts.length;
        var itemsLength = self.items.length;
        if (textsLength < itemsLength) {
          var removeList = self.items.splice(textsLength, itemsLength - textsLength);
          removeList.forEach(function (item) {
            self.$el.removeChild(item.el);
          });
        }
      }

      // destroy
    }, {
      key: "destroy",
      value: function destroy() {
        var self = this;
        self.interval = null;
        // clear in TagCloud.list
        var index = TagCloud.list.findIndex(function (e) {
          return e.el === self.$el;
        });
        if (index !== -1) TagCloud.list.splice(index, 1);
        // clear element
        if (self.$container && self.$el) {
          self.$container.removeChild(self.$el);
        }
      }
    }, {
      key: "pause",
      value: function pause() {
        var self = this;
        self.paused = true;
      }
    }, {
      key: "resume",
      value: function resume() {
        var self = this;
        self.paused = false;
      }
    }], [{
      key: "_on",
      value:
      // event listener
      function _on(el, ev, handler, cap) {
        if (el.addEventListener) {
          el.addEventListener(ev, handler, cap);
        } else if (el.attachEvent) {
          el.attachEvent("on".concat(ev), handler);
        } else {
          el["on".concat(ev)] = handler;
        }
      }
    }]);
    return TagCloud;
  }();
  TagCloud.list = [];
  // default config
  TagCloud._defaultConfig = {
    radius: 100,
    // rolling radius, unit `px`
    maxSpeed: 'normal',
    // rolling max speed, optional: `slow`, `normal`(default), `fast`
    initSpeed: 'normal',
    // rolling init speed, optional: `slow`, `normal`(default), `fast`
    direction: 135,
    // rolling init direction, unit clockwise `deg`, optional: `0`(top) , `90`(left), `135`(right-bottom)(default)...
    keep: true,
    // whether to keep rolling after mouse out area, optional: `false`, `true`(default)(decelerate to rolling init speed, and keep rolling with mouse)
    reverseDirection: false,
    useContainerInlineStyles: true,
    useItemInlineStyles: true,
    containerClass: 'tagcloud',
    itemClass: 'tagcloud--item',
    useHTML: false
  };
  // speed value
  TagCloud._getMaxSpeed = function (name) {
    return {
      slow: 0.5,
      normal: 1,
      fast: 2
    }[name] || 1;
  };
  TagCloud._getInitSpeed = function (name) {
    return {
      slow: 16,
      normal: 32,
      fast: 80
    }[name] || 32;
  };
  var index = (function (els, texts, options) {
    if (typeof els === 'string') els = document.querySelectorAll(els);
    if (!els.forEach) els = [els];
    var instances = [];
    els.forEach(function (el) {
      if (el) {
        instances.push(new TagCloud(el, texts, options));
      }
    });
    return instances.length <= 1 ? instances[0] : instances;
  });

  return index;

})));


/***/ }),

/***/ "bOdI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("C4MV");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),

/***/ "i1pD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('md-toolbar',{staticClass:"md-dense",staticStyle:{"padding-right":"0px","color":"black"},attrs:{"id":"toolbar"}},[_c('md-avatar',[_c('img',{attrs:{"src":"/static/SlinkTextLogo96.png","alt":"Slink Logo"}})]),_vm._v(" "),_c('h1',{staticClass:"md-title",staticStyle:{"flex":"1","text-align":"left","font-size":"25px","padding-left":"5px"}}),_vm._v(" "),(_vm.country !== 'IN')?_c('div',{staticStyle:{"display":"inline-flex","gap":"10px","padding":"8px"}},[_c('md-button',{staticClass:"toolbarButtons md-raised md-dense",staticStyle:{"margin":"unset","min-width":"unset","border-radius":"8px","padding-left":"12px","padding-right":"12px"},attrs:{"id":"loginMenu"},on:{"click":function($event){_vm.openDialog('loginDialog'); _vm.gGALog('Home','CTA', 'Login Button - Toolbar')}}},[_vm._v("Log In\n      ")]),_vm._v(" "),_c('md-button',{staticClass:"toolbarButtons md-raised md-dense",staticStyle:{"margin":"unset","min-width":"unset","border-radius":"8px","padding-left":"12px","padding-right":"12px"},attrs:{"id":"signupMenu"},on:{"click":function($event){_vm.openDialog('signupDialog'); _vm.gGALog('Home','CTA', 'SignUp Button - Toolbar')}}},[_vm._v("Sign Up\n      ")])],1):_vm._e()],1),_vm._v(" "),(_vm.country !== 'IN')?_c('md-dialog',{ref:"loginDialog",staticClass:"fullScreenDialog",attrs:{"md-click-outside-to-close":false}},[_c('md-dialog-title',{staticStyle:{"text-align":"center"}},[_vm._v("Welcome back!")]),_vm._v(" "),_c('md-dialog-content',{staticStyle:{"width":"100%"}},[_c('md-layout',[_c('md-layout',{attrs:{"md-hide-small":"","md-hide-medium":"","md-flex-large":"33"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-small":"100","md-flex-medium":"100","md-flex-large":"33"}},[_c('div',{staticClass:"slinkContainer",staticStyle:{"padding":"15px","padding-bottom":"0px","border-radius":"10px"}},[_c('p',{staticStyle:{"width":"100%","text-align":"center","font-size":"14px"}},[_vm._v("LOG IN WITH EMAIL")]),_vm._v(" "),_c('md-input-container',{staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('md-input',{attrs:{"autocomplete":"username","name":"loginEmail","required":""},model:{value:(_vm.loginEmail),callback:function ($$v) {_vm.loginEmail=$$v},expression:"loginEmail"}})],1),_vm._v(" "),_c('md-input-container',{staticStyle:{"margin-bottom":"10px"},attrs:{"md-has-password":""}},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password","autocomplete":"current-password","required":""},model:{value:(_vm.loginPassword),callback:function ($$v) {_vm.loginPassword=$$v},expression:"loginPassword"}})],1),_vm._v(" "),_c('div',[_c('md-button',{staticClass:"md-accent md-raised rounded5",staticStyle:{"margin":"10px 0","width":"100%"},attrs:{"disabled":!(_vm.loginEmail && _vm.loginPassword)},on:{"click":function($event){return _vm.loginByEmail()}}},[_vm._v("Login")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-dense md-primary rounded10",staticStyle:{"width":"100%","margin":"unset","text-transform":"unset"},on:{"click":function($event){return _vm.forgotPassword(_vm.loginEmail)}}},[_vm._v("Forgot your password?")])],1),_vm._v(" "),_c('p',{staticStyle:{"width":"100%","text-align":"center","margin":"10px"}},[_vm._v("OR")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised googleBtn",staticStyle:{"width":"100%","border-radius":"10px"},on:{"click":function($event){return _vm.loginByGoogle()}}},[_c('img',{staticStyle:{"font-size":"16px","width":"24px","margin-right":"10px","margin-top":"10px","margin-bottom":"10px"},attrs:{"src":"/static/images/home/googleg_color.png"}}),_vm._v("Log In with Google")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-hide-small":"","md-hide-medium":"","md-flex-large":"33"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('md-dialog',{ref:"signupDialog",staticClass:"fullScreenDialog"},[_c('md-dialog-title',{staticStyle:{"text-align":"center","font-weight":"bold"}},[_vm._v("Sign Up\n          ")]),_vm._v(" "),(_vm.country !== 'IN')?_c('md-dialog-content',[_c('md-layout',[_c('md-layout',{attrs:{"md-hide-small":"","md-hide-medium":"","md-flex-large":"33"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-small":"100","md-flex-medium":"100","md-flex-large":"33"}},[_c('div',{staticClass:"slinkContainer",staticStyle:{"padding":"15px","border-radius":"10px"}},[_c('p',{staticStyle:{"width":"100%","text-align":"center","font-size":"14px"}},[_vm._v("SIGN UP WITH EMAIL")]),_vm._v(" "),_c('md-input-container',{staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('md-input',{staticStyle:{"font-size":"18px !important"},attrs:{"autocomplete":"email","required":""},model:{value:(_vm.signupEmail),callback:function ($$v) {_vm.signupEmail=$$v},expression:"signupEmail"}})],1),_vm._v(" "),_c('md-input-container',{staticStyle:{"margin-bottom":"5px"},attrs:{"md-has-password":""}},[_c('label',[_vm._v("Password")]),_vm._v(" "),_c('md-input',{attrs:{"type":"password","autocomplete":"new-password","required":""},model:{value:(_vm.signupPassword),callback:function ($$v) {_vm.signupPassword=$$v},expression:"signupPassword"}})],1),_vm._v(" "),_c('div',[_c('md-button',{staticClass:"md-raised rounded5",staticStyle:{"width":"100%","margin":"10px 0 0px 0"},attrs:{"disabled":!(_vm.signupEmail && _vm.signupPassword)},on:{"click":function($event){return _vm.signupByEmail()}}},[_vm._v("Sign Up")])],1)],1),_vm._v(" "),_c('p',{staticStyle:{"width":"100%","text-align":"center","margin":"10px"}},[_vm._v("OR")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised googleBtn",staticStyle:{"width":"100%","border-radius":"10px"},on:{"click":function($event){return _vm.loginByGoogle()}}},[_c('img',{staticStyle:{"font-size":"16px","width":"24px","margin-right":"10px","margin-top":"10px","margin-bottom":"10px"},attrs:{"src":"/static/images/home/googleg_color.png"}}),_vm._v("Sign Up with Google")]),_vm._v(" "),_c('p',{attrs:{"STYLE":"font-size:smaller; text-align:center;margin-top:30px;width:100%"}},[_vm._v("The sign up process will add you to our mailing list.")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-hide-small":"","md-hide-medium":"","md-flex-large":"33"}})],1)],1):_c('md-dialog-content',[_vm._v("\n          We are no longer accepting sign-ups from this region.\n          ")])],1),_vm._v(" "),(_vm.isDev)?_c('div',{staticClass:"slider"},[_vm._m(0),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),_c('md-layout',{staticStyle:{"margin-top":"5vh"}},[_c('md-layout',{staticStyle:{"background":"white"},attrs:{"md-hide-xsmall":"","md-hide-small":"","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}}),_vm._v(" "),_c('md-layout',{staticStyle:{"padding-top":"10vh"},attrs:{"md-hide-xsmall":"","md-hide-small":"","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30","md-align":"end"}},[_c('div',{staticStyle:{"text-align":"left","padding-left":"35px","font-size":"3.5vw","font-weight":"bolder","line-height":"1.1","margin-bottom":"0px","width":"100%"}},[_vm._v("\n            Slink: Your digital"),_c('br'),_vm._v("business card.\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"left","padding":"25px 0px 0px 35px","width":"100%","height":"100%","font-size":"20px","line-height":"1.2"}},[_vm._v("\n            All your social media, streaming, ecommerce & websites links in one place.\n            "),_c('p',{staticStyle:{"font-size":"20px","line-height":"1.2"}},[_vm._v("One link you share everywhere.")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-warn signupBtn",on:{"click":function($event){_vm.openDialog('signupDialog'); _vm.gGALog('Home','CTA', ' SignUp Button - Intro')}}},[_vm._v("Sign Up for Free")])],1)]),_vm._v(" "),_c('md-layout',{staticStyle:{"background-image":"url('/static/images/home/splash.png')","background-size":"contain","background-repeat":"no-repeat,no-repeat","background-position":"center","margin-left":"auto","margin-right":"auto"},attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"30","md-flex-large":"30","md-flex-xlarge":"30","md-align":"center"}},[_c('div',{staticClass:"phone",staticStyle:{"width":"calc(160px + 5vw)","border-radius":"20px","padding":"7px","box-shadow":"0 50px 100px -20px rgb(50 50 93 / 25%), 0 30px 60px -30px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%)","background":"#f6f9fc"}},[_c('div',{staticClass:"fling-minislide",attrs:{"id":"frame"}},[_c('img',{staticStyle:{"width":"100%","object-fit":"unset"},attrs:{"src":"https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/aokmusic_qj_8uWh2I.png","id":"scrn1"}}),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","object-fit":"unset"},attrs:{"src":"https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/mttradingbot_jqfrmpQcj.png","id":"scrn1"}}),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","object-fit":"unset"},attrs:{"src":"https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/misssperu_S5Ul4TyKr.png","id":"scrn1"}}),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","object-fit":"unset"},attrs:{"src":"https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/emtfilms_C-1nJmS-Ra.png"}}),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","object-fit":"unset"},attrs:{"src":"https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/goub_Ju25naL7M.png"}}),_vm._v(" "),_c('img',{staticStyle:{"width":"100%","object-fit":"unset"},attrs:{"src":"https://ik.imagekit.io/slink/tr:n-screenshot/Home_Screenshots/modenaautomotive_sa_pWvJxHd.png"}})])])]),_vm._v(" "),_c('md-layout',{staticStyle:{"background":"white"},attrs:{"md-hide-xsmall":"","md-hide-small":"","md-flex-medium":"20","md-flex-large":"20","md-flex-xlarge":"20"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-hide-medium-and-up":""}},[_c('div',{staticStyle:{"text-align":"center","padding":"20px","font-size":"2.5rem","font-weight":"bolder","line-height":"1.1","font-family":"unset","margin-bottom":"0px","width":"100%"}},[_vm._v("\n            Slink: Your digital business card.\n          ")]),_vm._v(" "),_c('div',{staticStyle:{"padding":"0px 25px","width":"100%","height":"100%","font-size":"16px","line-height":"1.4"}},[_vm._v("\n            All your social media, streaming, ecommerce & websites links in one place.\n            "),_c('p',{staticStyle:{"font-size":"16px","line-height":"1.4"}},[_vm._v("One link you share everywhere.")]),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-warn signupBtn",on:{"click":function($event){_vm.openDialog('signupDialog'); _vm.gGALog('Home','CTA', ' SignUp Button - Intro')}}},[_vm._v("Sign Up for Free")])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"20px"}},[_c('h2',[_vm._v("HOW IT WORKS")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('md-button',{staticClass:"md-raised md-warn signupBtn",on:{"click":function($event){_vm.openDialog('signupDialog'); _vm.gGALog('Home','CTA', ' SignUp Button - Intro')}}},[_vm._v("Sign Up for Free")])],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"20px"}},[_c('h2',[_vm._v("WHY SLINK?")]),_vm._v(" "),_c('md-layout',[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-card',{staticStyle:{"border-radius":"15px","margin":"10px","width":"100%"}},[_c('md-card-media',[_c('img',{staticStyle:{"max-height":"200px","padding":"0px"},attrs:{"src":"/static/images/admin/grow.svg","alt":"People"}})]),_vm._v(" "),_c('md-card-header',{staticStyle:{"padding-top":"revert"}},[_c('div',{staticClass:"md-title"},[_vm._v("Grow your audience!")])]),_vm._v(" "),_c('md-card-content',[_vm._v("\n    Add links to any social media platform, website, e-commerce store.. anywhere!\n  ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-card',{staticStyle:{"border-radius":"15px","margin":"10px","width":"100%"}},[_c('md-card-media',[_c('img',{staticStyle:{"max-height":"200px","padding":"0px"},attrs:{"src":"/static/images/admin/monetise.svg","alt":"People"}})]),_vm._v(" "),_c('md-card-header',{staticStyle:{"padding-top":"revert"}},[_c('div',{staticClass:"md-title"},[_vm._v("Monetise your platforms!")])]),_vm._v(" "),_c('md-card-content',[_vm._v("\n    Add payment links, products, subscriptions....\n  ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-card',{staticStyle:{"border-radius":"15px","margin":"10px","width":"100%"}},[_c('md-card-media',[_c('img',{staticStyle:{"max-height":"200px","padding":"0px"},attrs:{"src":"/static/images/admin/media.svg","alt":"People"}})]),_vm._v(" "),_c('md-card-header',{staticStyle:{"padding-top":"revert"}},[_c('div',{staticClass:"md-title"},[_vm._v("Release audio & video content!")])]),_vm._v(" "),_c('md-card-content',[_vm._v("\n    Promote new songs, new YouTube videos even stream your games live!\n  ")])],1)],1)],1),_vm._v(" "),_c('md-layout',[_c('md-layout',{attrs:{"md-flex-xsmall":"0","md-flex-small":"0","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-button',{staticClass:"md-raised md-warn signupBtn",staticStyle:{"width":"190.35px","margin-left":"auto","margin-right":"auto","margin-top":"20px"},on:{"click":function($event){_vm.openDialog('signupDialog'); _vm.gGALog('Home','CTA', ' SignUp Button - Steps')}}},[_vm._v("Sign Up for free")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"0","md-flex-small":"0","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin":"20px"}},[_c('h2',[_vm._v("WHAT NEXT?")]),_vm._v(" "),_c('md-layout',[_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-card',{staticStyle:{"border-radius":"15px","margin":"10px","width":"100%"}},[_c('md-card-media',[_c('img',{staticStyle:{"max-height":"200px","padding":"0px"},attrs:{"src":"/static/images/admin/register.svg","alt":"People"}})]),_vm._v(" "),_c('md-card-header',{staticStyle:{"padding-top":"revert"}},[_c('div',{staticClass:"md-title"},[_vm._v("1. Sign up for FREE")])]),_vm._v(" "),_c('md-card-content',[_vm._v("\n    Pick your own unique Slink address."),_c('br'),_vm._v("Love it, cherish it, share it!\n  ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-card',{staticStyle:{"border-radius":"15px","margin":"10px","width":"100%"}},[_c('md-card-media',[_c('img',{staticStyle:{"max-height":"200px","padding":"0px"},attrs:{"src":"/static/images/admin/build.svg","alt":"People"}})]),_vm._v(" "),_c('md-card-header',{staticStyle:{"padding-top":"revert"}},[_c('div',{staticClass:"md-title"},[_vm._v("2. Build your page")])]),_vm._v(" "),_c('md-card-content',[_vm._v("\n    Add your social media, streaming links,"),_c('br'),_vm._v("website and content to your page\n  ")])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-card',{staticStyle:{"border-radius":"15px","margin":"10px","width":"100%"}},[_c('md-card-media',[_c('img',{staticStyle:{"max-height":"200px","padding":"0px"},attrs:{"src":"/static/images/admin/sharepage.svg","alt":"People"}})]),_vm._v(" "),_c('md-card-header',{staticStyle:{"padding-top":"revert"}},[_c('div',{staticClass:"md-title"},[_vm._v("3. Share it everywhere")])]),_vm._v(" "),_c('md-card-content',[_vm._v("\n    Share your Slink URL everywhere,"),_c('br'),_vm._v("Instagram, Twitter, Snapchat, Email, anywhere!\n  ")])],1)],1)],1),_vm._v(" "),_c('md-layout',[_c('md-layout',{attrs:{"md-flex-xsmall":"0","md-flex-small":"0","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-button',{staticClass:"md-raised md-warn signupBtn",staticStyle:{"width":"190.35px","margin-left":"auto","margin-right":"auto","margin-top":"20px"},on:{"click":function($event){_vm.openDialog('signupDialog'); _vm.gGALog('Home','CTA', ' SignUp Button - Steps')}}},[_vm._v("Sign Up for free")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"0","md-flex-small":"0","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}})],1)],1),_vm._v(" "),_c('div',[_c('md-layout',[_c('md-layout',{attrs:{"md-hide-xsmall":"","md-hide-small":"","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('div',{staticStyle:{"text-align":"center","width":"100%"}},[_c('center',[_c('h2',[_vm._v("HAPPY SLINKERS")]),_vm._v(" "),_c('h3',{staticStyle:{"margin":"unset"}},[_vm._v("Who  uses Slink?")]),_vm._v(" "),_c('ul',{staticClass:"happySlinkersUL"},[_c('li',{staticStyle:{"margin-left":"25px","margin-right":"25px"}},[_c('strong',[_vm._v("Model, Bloggers & Influencers")]),_vm._v(" - add your social media links, blog/vlog links and even your online stores such as Depop, etc")]),_vm._v(" "),_c('li',{staticStyle:{"margin-left":"25px","margin-right":"25px"}},[_c('strong',[_vm._v("Singers & Artists")]),_vm._v(" - promote your music on all platforms, stream audio and video from the likes of Spotify and YouTube")])])])],1),_vm._v(" "),_c('md-boards',{attrs:{"md-auto":true,"md-infinite":true,"md-controls":false,"md-duration":10000,"md-swipeable":true}},[_c('md-board',{attrs:{"id":"review000"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"/static/images/home/jaybrave.jpg"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      Gone are the days of me forwarding random links from different sites which no one ever ends up looking at - Slink changes everything!\n                    ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                      Jay Brave\n                    ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review001"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fingmarwein.jfif?alt=media&token=7f1914dd-d9a0-4814-95aa-4c4d0ab9cebb"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                       Been using Slink to promote all my social media and blog/website links for a while now, and I love their service! 👌👌\n                    ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                      Ingmar Wein\n                    ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review002"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fjoeybase.jpg?alt=media&token=18edeb57-3c21-4306-993f-6dc5b1f08770"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      Before Slink I struggled to promote all my music at the same time.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                      Joey Base\n                    ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review003"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fshaewise.jpg?alt=media&token=4f497919-21f9-4de5-8cbf-29bf687e3354"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      Very helpful marketing app, especially for influencers like myself. I love the easy to use UI and the versatility of the home page.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                      Shae Vena\n                    ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review004"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fdanidaizee.jpg?alt=media&token=4fc1b7b8-2478-4d12-b3a3-6d20d2094ccd"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      Can’t recommend Slink enough. They go above & beyond always. From customer services to generally just making life a lot easier.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                      Dani Daizee\n                    ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review005"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fvince.jpg?alt=media&token=776b358e-baa3-40a3-bfc8-d5e874a44883"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      Fantastic team, great response. Always happy with the service they provide\n                  ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                    Vincent Azzopardi\n                  ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review006"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fvicky.jpg?alt=media&token=80ef2dee-e93f-46e5-86a2-8827a8f45bd8"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      Love this, use it for business and always recommend as it’s so easy to share when out and about and really handy when networking online.\n                  ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                    Vicky Cunningham\n                  ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review007"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Fworthington.jpg?alt=media&token=d0d3141e-f7bc-4a1f-acf2-ad6c7eb57b7b"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      The slink card is very handy when I'm out of business cards or in this pandemic situation where I don't want to hand someone something physical.\n                  ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                    Gareth Worthington\n                  ")])])])]),_vm._v(" "),_c('md-board',{attrs:{"id":"review008"}},[_c('div',{staticClass:"testimonial"},[_c('img',{attrs:{"src":"https://firebasestorage.googleapis.com/v0/b/slink-64a53.appspot.com/o/static%2Ftestimonials%2Frheo.jpg?alt=media&token=2139943c-75c5-44d0-8dff-ea327be4ce0e"}}),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"review"},[_vm._v("\n                      It is vital for me to get my social media links to the right people accurately and quickly, there is no better way to achieve this other than using Slink! Simple, effective, stylish!\n                  ")]),_vm._v(" "),_c('div',{staticClass:"name"},[_vm._v("\n                    Rheo\n                  ")])])])])],1)],1),_vm._v(" "),_c('md-layout',{attrs:{"md-hide-xsmall":"","md-hide-small":"","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"20px"}},[_c('h2',[_vm._v("Are you ready to become a social media superhero?")]),_vm._v(" "),_c('IconCloud',{attrs:{"items":_vm.logos,"options":{ radius: 250, maxSpeed: 'fast', keep: true }}}),_vm._v(" "),_c('md-layout',[_c('md-layout',{attrs:{"md-hide-xsmall":"","md-hide-small":"","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}}),_vm._v(" "),_c('md-layout',{attrs:{"md-flex-xsmall":"100","md-flex-small":"100","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}},[_c('md-button',{staticClass:"md-raised md-warn signupBtn",staticStyle:{"width":"190.35px","margin-left":"auto","margin-right":"auto","margin-top":"20px"},on:{"click":function($event){_vm.openDialog('signupDialog'); _vm.gGALog('Home','CTA', ' SignUp Button - Superhero')}}},[_vm._v("Sign Up for free")])],1),_vm._v(" "),_c('md-layout',{attrs:{"md-hide-xsmall":"","md-hide-small":"","md-flex-medium":"33","md-flex-large":"33","md-flex-xlarge":"33"}})],1),_vm._v(" "),_c('div',{staticStyle:{"padding-top":"40px","font-size":"small"}},[_c('md-button',{staticClass:"md-icon-button",staticStyle:{"color":"#3b5998"},attrs:{"href":"https://www.facebook.com/getslink/","target":"_blank"}},[_c('md-icon',{staticStyle:{"font-size":"medium"},attrs:{"md-iconset":"fa fa-facebook"}})],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",staticStyle:{"color":"#e1306c"},attrs:{"href":"https://www.instagram.com/slinkapp","target":"_blank"}},[_c('md-icon',{staticStyle:{"font-size":"medium"},attrs:{"md-iconset":"fa fa-instagram"}})],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",staticStyle:{"color":"#1da1f2"},attrs:{"href":"https://www.twitter.com/slink_app","target":"_blank"}},[_c('md-icon',{staticStyle:{"font-size":"medium"},attrs:{"md-iconset":"fa fa-twitter"}})],1),_vm._v(" "),_c('md-button',{staticClass:"md-icon-button",staticStyle:{"-webkit-text-fill-color":"white","-webkit-text-stroke-width":"1px","-webkit-text-stroke-color":"black"},attrs:{"href":"https://www.snapchat.com/add/slinkapp","target":"_blank"}},[_c('md-icon',{staticStyle:{"font-size":"medium"},attrs:{"md-iconset":"fa fa-snapchat-ghost"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"50px","text-transform":"uppercase","font-size":"smaller"}},[_vm._v("Made with ❤️ in London")])],1)],1),_vm._v(" "),_c('md-snackbar',{ref:"snackbar",attrs:{"md-duration":4200}},[_c('span',[_vm._v(_vm._s(_vm.notification))]),_vm._v(" "),_c('md-button',{on:{"click":function($event){return _vm.$refs.snackbar.close()}}},[_vm._v("OK")])],1),_vm._v(" "),_c('md-button',{staticClass:"md-fab md-mini",staticStyle:{"z-index":"99","padding":"0","min-width":"unset","position":"fixed","right":"10px","bottom":"10px"},on:{"click":function($event){return _vm.openExternal('https://tawk.to/chat/67b85c0ac3759e190c7859b5/1ikk2f2n9')}}},[_c('md-icon',[_vm._v("help_outline")])],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/R4Mj2kT/jT.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/WFP9dvc/gK.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/W5j0nSL/bS.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/cbS52z7/rjb.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/pRcRhWh/cW.jpg","alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/R4Mj2kT/jT.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/WFP9dvc/gK.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/W5j0nSL/bS.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/cbS52z7/rjb.jpg","alt":""}})])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"phone"},[_c('img',{attrs:{"src":"https://i.ibb.co/pRcRhWh/cW.jpg","alt":""}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"driftvideo",staticStyle:{"position":"relative","overflow":"hidden","margin-left":"auto","margin-right":"auto","border-radius":"15px","box-shadow":"0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)","max-width":"475px"}},[_c('iframe',{staticStyle:{"min-height":"200px"},attrs:{"id":"ytplayer","type":"text/html","width":"720","height":"405","src":"https://www.youtube.com/embed/aCRH1v7qxAQ?fs=0&loop=1&modestbranding=1&playsinline=1&start=4&color=white","frameborder":"0","allowfullscreen":""}}),_vm._v(" "),_c('p',{staticStyle:{"margin":"10px"}},[_vm._v("Slink User - Eddie Melendez aka \"EMT\" is the creator of EMT Films, he explains how Slink and the Slink Card works.\n          ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ivoi":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("ncMf");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("6930320a", content, true, {});

/***/ }),

/***/ "jJbG":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("Bz0q");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("557eca38", content, true, {});

/***/ }),

/***/ "lgQ+":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".cloud-icon[data-v-367ba28c]{background-size:contain;background-repeat:no-repeat;background-position:50%;width:32px;height:32px;display:inline-block;border-radius:5px;overflow:hidden}.icon-cloud[data-v-367ba28c]{width:100%;height:320px;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.icon-cloud a[data-v-367ba28c],.icon-cloud img[data-v-367ba28c],.icon-cloud span[data-v-367ba28c]{display:inline-block;font-size:14px;line-height:1}.icon-cloud .cloud-icon[data-v-367ba28c],.icon-cloud img[data-v-367ba28c]{width:32px;height:32px;-o-object-fit:contain;object-fit:contain;-webkit-transition:-webkit-transform .2s ease;transition:-webkit-transform .2s ease;transition:transform .2s ease;transition:transform .2s ease,-webkit-transform .2s ease}.icon-cloud .cloud-icon[data-v-367ba28c]:hover,.icon-cloud img[data-v-367ba28c]:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}", "", {"version":3,"sources":["C:/Users/ismet/Documents/Github/slink_vue/src/components/iconCloud.vue"],"names":[],"mappings":"AACA,6BACE,wBAAyB,AACzB,4BAA6B,AAC7B,wBAA4B,AAC5B,WAAY,AACZ,YAAa,AACb,qBAAsB,AACtB,kBAAmB,AACnB,eAAiB,CAClB,AACD,6BACE,WAAY,AACZ,aAAc,AACd,kBAAmB,AAEnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,sBAAwB,CACjC,AACD,kGAIE,qBAAsB,AACtB,eAAgB,AAChB,aAAe,CAChB,AACD,0EAEE,WAAY,AACZ,YAAa,AACb,sBAAuB,AACpB,mBAAoB,AACvB,8CAAgD,AAChD,sCAAwC,AACxC,8BAAgC,AAChC,wDAA6D,CAC9D,AACD,sFAEE,6BAA8B,AACtB,oBAAsB,CAC/B","file":"iconCloud.vue","sourcesContent":["\n.cloud-icon[data-v-367ba28c] {\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: center;\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  border-radius: 5px;\n  overflow: hidden;\n}\n.icon-cloud[data-v-367ba28c] {\n  width: 100%;\n  height: 320px;\n  position: relative;\n  /* Optional: centre it nicely inside a card/section */\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.icon-cloud a[data-v-367ba28c],\n.icon-cloud span[data-v-367ba28c],\n.icon-cloud img[data-v-367ba28c] {\n  /* tweak sizing/appearance of entries */\n  display: inline-block;\n  font-size: 14px;\n  line-height: 1;\n}\n.icon-cloud img[data-v-367ba28c],\n.icon-cloud .cloud-icon[data-v-367ba28c] {\n  width: 32px;\n  height: 32px;\n  -o-object-fit: contain;\n     object-fit: contain;\n  -webkit-transition: -webkit-transform 0.2s ease;\n  transition: -webkit-transform 0.2s ease;\n  transition: transform 0.2s ease;\n  transition: transform 0.2s ease, -webkit-transform 0.2s ease;\n}\n.icon-cloud img[data-v-367ba28c]:hover,\n.icon-cloud .cloud-icon[data-v-367ba28c]:hover {\n  -webkit-transform: scale(1.1);\n          transform: scale(1.1);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "ncMf":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(true);
// imports


// module
exports.push([module.i, ".phone{aspect-ratio:1080/1920;width:150px;border-radius:10px;padding:7px;-webkit-box-shadow:0 5px 10px -2px rgb(50 50 93/25%),0 3px 6px -1px rgb(0 0 0/30%),inset 0 -2px 6px 0 rgb(10 37 64/35%);box-shadow:0 5px 10px -2px rgb(50 50 93/25%),0 3px 6px -1px rgb(0 0 0/30%),inset 0 -2px 6px 0 rgb(10 37 64/35%);background:#f6f9fc;overflow:hidden}.slider .phone img{aspect-ratio:1080/1920;border-radius:5px;width:100%;max-height:95%;-o-object-position:top;object-position:top;border:1px solid silver}.slider{width:100vw;margin:auto;overflow:hidden}.slider,.slider ul{white-space:nowrap;display:inline-block}.slider ul{padding:0;-webkit-animation:infinislide 15s infinite linear;animation:infinislide 15s infinite linear}.slider li{padding:0 10px;list-style:none}.slider img{max-width:150px;width:150px;aspect-ratio:1/1;-o-object-fit:cover;object-fit:cover;-o-object-position:center;object-position:center;height:auto!important}@-webkit-keyframes infinislide{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}@keyframes infinislide{0%{-webkit-transform:translateX(0);transform:translateX(0)}to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}}", "", {"version":3,"sources":["C:/Users/ismet/Documents/Github/slink_vue/src/components/home.vue"],"names":[],"mappings":"AACA,OACE,uBAAuB,AACvB,YAAa,AACb,mBAAoB,AACpB,YAAa,AAEb,wHAAiI,AACzH,gHAAyH,AACjI,mBAAoB,AACpB,eAAiB,CAClB,AACD,mBACE,uBAAwB,AACxB,kBAAkB,AAClB,WAAW,AACX,eAAgB,AAChB,uBAAwB,AACrB,oBAAqB,AACxB,uBAAwB,CACzB,AACD,QACI,YAAa,AACb,YAAa,AACb,eAAiB,CAGpB,AACD,mBAHI,mBAAoB,AACpB,oBAAsB,CAQzB,AAND,WAGI,UAAW,AACX,kDAAmD,AAC3C,yCAA2C,CACtD,AACD,WACI,eAAe,AACf,eAAiB,CACpB,AACD,YAEI,gBAAgB,AAChB,YAAY,AACZ,iBAAiB,AACjB,oBAAoB,AACjB,iBAAiB,AACpB,0BAA2B,AACxB,uBAAwB,AAC3B,qBAAwB,CAC3B,AACD,+BACA,GACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,GACI,oCAAqC,AAC7B,2BAA6B,CACxC,CACA,AACD,uBACA,GACI,gCAAiC,AACzB,uBAAyB,CACpC,AACD,GACI,oCAAqC,AAC7B,2BAA6B,CACxC,CACA","file":"home.vue","sourcesContent":["\n.phone{\r\n  aspect-ratio:1080/1920; \r\n  width: 150px; \r\n  border-radius: 10px; \r\n  padding: 7px; \r\n  /* box-shadow: 0 50px 100px -20px rgb(50 50 93 / 25%), 0 30px 60px -30px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%);  */\r\n  -webkit-box-shadow: 0 5px 10px -2px rgb(50 50 93 / 25%), 0 3px 6px -1px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%);\r\n          box-shadow: 0 5px 10px -2px rgb(50 50 93 / 25%), 0 3px 6px -1px rgb(0 0 0 / 30%), inset 0 -2px 6px 0 rgb(10 37 64 / 35%);\r\n  background: #f6f9fc;\r\n  overflow: hidden;\n}\n.slider .phone img{\r\n  aspect-ratio: 1080/1920;\r\n  border-radius:5px;\r\n  width:100%;\r\n  max-height: 95%;\r\n  -o-object-position: top;\r\n     object-position: top;\r\n  border:1px solid silver;\n}\n.slider {\r\n    width: 100vw;\r\n    margin: auto;\r\n    overflow: hidden;\r\n    white-space: nowrap;\r\n    display: inline-block;\n}\n.slider ul {\r\n    display: inline-block;\r\n    white-space: nowrap;\r\n    padding: 0;\r\n    -webkit-animation: infinislide 15s infinite linear;\r\n            animation: infinislide 15s infinite linear;\n}\n.slider li {\r\n    padding:0 10px;\r\n    list-style: none;\n}\n.slider img {\r\n    /* max-width: fit-content !important; */\r\n    max-width:150px;\r\n    width:150px;\r\n    aspect-ratio:1/1;\r\n    -o-object-fit:cover;\r\n       object-fit:cover;\r\n    -o-object-position: center;\r\n       object-position: center;\r\n    height: auto !important;\n}\n@-webkit-keyframes infinislide {\nfrom {\r\n    -webkit-transform: translateX(0);\r\n            transform: translateX(0);\n}\nto {\r\n    -webkit-transform: translateX(-100%);\r\n            transform: translateX(-100%);\n}\n}\n@keyframes infinislide {\nfrom {\r\n    -webkit-transform: translateX(0);\r\n            transform: translateX(0);\n}\nto {\r\n    -webkit-transform: translateX(-100%);\r\n            transform: translateX(-100%);\n}\n}\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ "rKx+":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("4ajQ");
var $Object = __webpack_require__("iANj").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "sFnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tagcloud__ = __webpack_require__("Tksi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tagcloud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tagcloud__);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'IconCloud',
  props: {
    // Array of icon URLs
    items: {
      type: Array,
      required: true // e.g. ['/icons/vue.svg', '/icons/react.png', '/icons/angular.svg']
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          radius: 140, // px
          maxSpeed: 'normal', // 'slow', 'normal', 'fast'
          initSpeed: 'normal',
          keep: true // keep spinning after mouse leaves
        };
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    // Create simple text labels for TagCloud positioning
    var labels = this.items.map(function (url, index) {
      return 'icon-' + index;
    });

    // Initialize TagCloud with simple text labels
    this._cloud = __WEBPACK_IMPORTED_MODULE_0_tagcloud___default()(this.$refs.cloud, labels, this.options);

    // After TagCloud creates the structure, modify existing elements to show images
    this.$nextTick(function () {
      var cloudElements = _this.$refs.cloud.querySelectorAll('span');
      cloudElements.forEach(function (element, index) {
        if (index < _this.items.length) {
          var url = _this.items[index];
          var filename = url.split('/').pop().split('.')[0];

          // Clear the text content
          element.textContent = '';

          // Set the element's background image instead of replacing it
          element.style.backgroundImage = 'url(' + url + ')';
          element.style.backgroundSize = 'contain';
          element.style.backgroundRepeat = 'no-repeat';
          element.style.backgroundPosition = 'center';
          element.style.width = '32px';
          element.style.height = '32px';
          element.style.display = 'inline-block';
          element.className = 'cloud-icon';

          // Add alt text as a data attribute for accessibility
          element.setAttribute('data-alt', filename);
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    // TagCloud returns an instance with a destroy method (in recent versions)
    if (this._cloud && this._cloud.destroy) this._cloud.destroy();
  }
});

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06759b99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("i1pD");
function injectStyle (ssrContext) {
  __webpack_require__("ivoi")
  __webpack_require__("jJbG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06759b99"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06759b99_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/13.75edbd123127d84e3960.js